

import React, { useState, useContext } from 'react';
import { UserContext } from '../contexts/UserContext'; // Utilisation unique pour le contexte
import { db } from '../firebase'; 
import { collection, query, where, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // Accéder aux valeurs et setters depuis le UserContext
    const { user, setUser, setClient, setGerant } = useContext(UserContext);

    const saveWithExpiry = (key, data) => {
        const now = Date.now(); // Obtenir le timestamp actuel
        const expiryTime = now +  12 * 60 * 60 * 1000; // Expiration dans 24 heures
        const item = {
            ...data,
            expiry: expiryTime,
        };
      
        localStorage.setItem(key, JSON.stringify(item));
    };
    

    const handleLogin = async (e) => {
        console.log('Le formulaire est soumis');
        e.preventDefault();
        setError(''); // Réinitialiser l'erreur au début de la tentative de connexion
       
        try {
            const usersRef = collection(db, 'user');
            const q = query(usersRef, where('email', '==', email));
            const querySnapshot = await getDocs(q);
             
            
            // Vérification si l'utilisateur existe
            if (querySnapshot.empty) {
                setError('Utilisateur non trouvé.');
                return;
            }
    
            const userDoc = querySnapshot.docs[0];
            const userData = userDoc.data();
    
            // Vérification du mot de passe
            if (userData.password === password) {
                if (userData.role === 'Kuo8Wsgg6Q7l4ZGhbTf3') {
                    
                    // Admin login
                    const adminData = {
                        id: userDoc.id,
                        email: userData.email,
                        role: userData.role,
                        nom: userData.nom,
                        expiry: Date.now() + 12 * 60 * 60 * 1000,
                    };
                    saveWithExpiry('user', adminData);
                    setUser(adminData);
                    navigate('/admin');
                } else if (userData.role === 'pdqve0oMlifjYOu6p52Z') {
                    // Client login
                    const clientData = {
                        id: userDoc.id,
                        email: userData.email,
                        role: userData.role,
                        nom: userData.nom,
                        expiry: Date.now() + 12 * 60 * 60 * 1000,
                    };
                    saveWithExpiry('client', clientData);
                    setClient(clientData);
                    navigate('/boutique');
                } else if (userData.role === 'vJzeVIK0wjksSF9V2KW6') {
                  
                    // Gérant login
                    const gerantData = {
                        id: userDoc.id,
                        email: userData.email,
                        role: userData.role,
                        nom: userData.nom,
                        expiry: Date.now() + 12 * 60 * 60 * 1000,
                    };
                    saveWithExpiry('gerant', gerantData);
                    setGerant(gerantData);
                    navigate('/gerant');
                }
            } else {
                setError('Mot de passe incorrect.');
            }
            
        } catch (err) {
            console.error('Erreur de connexion:', err);
            setError('Erreur de connexion. Veuillez réessayer.');
        }
    };
    

    return (
        <div className="container d-flex justify-content-center align-items-start vh-100">
            <div className="card p-4 shadow-sm" style={{ maxWidth: '400px', width: '100%' }}>
                <h2 className="text-center mb-4">Connexion</h2>
                {error && <p className="text-danger text-center">{error}</p>}
                <form onSubmit={handleLogin}>
                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email</label>
                        <input
                            type="email"
                            className="form-control"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">Mot de passe</label>
                        <input
                            type="password"
                            className="form-control"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="btn btn-primary w-100">Se connecter</button>
                </form>
            </div>
        </div>
    );
};

export default Login;
